module.exports = __webpack_public_path__ + "img/3.654ecf89.png";